<script>
    import { onMount, onDestroy } from 'svelte';
    import Autocompolete from './Autocompolete.svelte';
    import { linear } from 'svelte/easing';
    import { slide } from 'svelte/transition';
    import { retrieveFromBlockCollection, updateAliases } from '../../../services/database';
    import { a, setMode } from '../../../shared/globalState/a';
    import { updateAndDrawShapes } from '../../../shared/render/shapes';
    import { Block } from '../../../models/shapes/Block';
    import { initForFreeTransform } from '../../../services/operations.ts';
    import { CommandList } from '../../../models/CommandList';
    import { take } from 'rxjs';
  

    export let isVisible = false;
    let left = 0;
    let top = 0;
    let data;
    let net;
    let transitionOptions = {
        duration: 100,
        easing: linear,
    };

    a.storedAliases$.subscribe((v) => {
        data = v;
    });

    function setContainer(element) {
        let rect = element.getBoundingClientRect();
        left = -rect.left - 2;
        top = -rect.top + 15;
    }

    /**
     * Функция срабатывает при выборе какого-то элемента в выпадающем списке
     */
    function handleAutocompolete(event) {
        var code = event.detail;

        // получить фигуру из базы данных по коду
        retrieveFromBlockCollection(code);
        // создать экземпляр фигуры из базы данных и добавить его в список фигур
        a.retrieveAlias$.pipe(take(1)).subscribe((dbObject) => {
            
            
            let block = Block.restoreFromDatabase(dbObject);

            // установить масштаб фигуры - это производная от сохранённого в фигуре и текущего масштабов
            let scale = a.zlc / dbObject.zlc;
            block.zoom(scale);
            

            block.isSelected = true;
            let cp1 = block.getCpoints().cp1;

            initForFreeTransform(block, cp1);

            a.clickCopyStart = cp1;
            setMode(CommandList.cm.copy.type);

            a.shapes.push(block);
            
            updateAndDrawShapes();
            isVisible = false;
        });
    }

</script>

{#if isVisible}
    <div class="container" use:setContainer transition:slide={transitionOptions}>
        <Autocompolete
            {data}
            placeholder="Выбор блока ...."
            {left}
            {top}
            isFocused={true}
            on:selected={handleAutocompolete}
            dataSearchPropertyName="code & desc"
            columns={['code','desc', 'kms', 'img']}></Autocompolete>
    </div>
{/if}

<style>
    .container {
        position: absolute;
        padding: 1em 2em;
        background-color: #f1f5f9;
        border: 1px solid slategray;
        border-radius: 5px;
        transform: translate(50%, 50px);
        max-width: 50%;
        z-index: 20;
    }
</style>
